import PazienteParametriVitali from "../";

const routes = [
    {
        name: "PazienteParametriVitali",
        path: "/paziente/parametrivitali",
        component: PazienteParametriVitali.PazienteParametriVitaliPage,
        meta: { title: "Parametri Vitali" },
    },
];

export default routes;
